module.exports = __webpack_public_path__ + "img/imgs2.b72569a5.png";